<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div
      v-if="activityStatus === 0"
      :class="`${$style.pageWrapper} ${$style.error_state}`"
    >
      活动未开始
    </div>
    <div
      v-else-if="activityStatus === 2"
      :class="`${$style.pageWrapper} ${$style.error_state}`"
    >
      活动已结束
    </div>
    <div v-else :class="`${$style.pageWrapper}`">
      <img :class="$style.pageBack" :src="pageBackground" />
      <div :class="`${$style.pageContent} ${$style.playPart}`">
        <h2 :class="$style.placeTitle">在玩游戏会场</h2>
        <div v-if="playGames.length > 0" :class="$style.gameList">
          <div
            v-for="game in playGames"
            :key="game.gameId"
            :class="$style.gameBox"
            @click="onSkipDetail(game)"
          >
            <img :src="game.gameIcon" alt="游戏图片" :class="$style.gameImg" />
            <div :class="$style.gameSection">
              <div :class="$style.gameTitle">{{ game.gameName }}</div>
              <div :class="$style.gameDesc">{{ game.price }}元礼包</div>
            </div>
          </div>
        </div>
        <div v-else :class="$style.empty">
          <p>暂无在玩游戏～</p>
          <p>请查看下方更多游戏会场，</p>
          <p>选择自己喜欢的游戏下载参与活动吧！</p>
        </div>
      </div>
      <div :class="`${$style.pageContent} ${$style.morePart}`">
        <h2 :class="$style.placeTitle">更多游戏会场</h2>
        <div v-if="moreGames.length > 0" :class="$style.gameList">
          <div
            v-for="game in moreGames"
            :key="game.gameId"
            :class="$style.gameBox"
            @click="onSkipDetail(game)"
          >
            <img :src="game.gameIcon" alt="游戏图片" :class="$style.gameImg" />
            <div :class="$style.gameSection">
              <div :class="$style.gameTitle">{{ game.gameName }}</div>
              <div :class="$style.gameDesc">{{ game.price }}元礼包</div>
            </div>
          </div>
        </div>
        <div v-else :class="$style.empty">
          <p>暂无更多游戏～</p>
        </div>
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1 } from "@/config";
import { burnPoint } from "@/apis/heziShare";
import {
  onGoBack,
  setPageTitle,
  getUserInfo,
  toLogin,
} from "@/bridge/AppJsBridge";
import { getActPlaceListApiV2 } from "@/apis/actPlace";
import { PullRefresh } from "vant";
import {
  getCookie,
  downloadTarget,
  checkIsWxBrowser,
  pageLoseTips,
} from "@/libs/utils";

export default {
  name: "",
  components: {
    PullRefresh,
  },
  data() {
    return {
      cdnLink: CDN_URL_1,
      pageTitle: '打卡活动',
      userInfo: "",
      hiddenTitle: false,
      giftInfo: null,
      cookie: null,
      isLoading: false,
      moreGames: [],
      playGames: [],
      activityStatus: 1, // 活动状态 0-未开始 1-进行中 2-已结束
      pageBackground: '',
    };
  },
  computed: {},

  created() {
    // 页面初始化
    inithandler();
    this.initPageData();
  },
  activated() {
    this.getActPlaceData();
  },
  mounted() {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event)
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },
    // 获取cookie、缓存等携带的用户信息数据
    async initPageData() {
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      getUserInfo((userInfo) => {
        this.userInfo = JSON.parse(userInfo);
        if (this.userInfo.token) {
          localStorage.setItem("token", this.userInfo.token);
        } else if (getCookie("token")) {
          localStorage.setItem("token", getCookie("token"));
          this.userInfo = { token: getCookie("token") };
        } else {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
          return;
        }
        this.getActPlaceData();
      });
    },

    getActPlaceData() {
      getActPlaceListApiV2().then((res) => {
        const { data } = res;
        this.activityId = data.activityId
        this.playGames = data.playGameVoList;
        this.moreGames = data.moreGameVoList;
        this.activityStatus = data.activityStatus
        this.pageBackground = data.background;
        this.pageTitle = data.name;
        document.title = data.name;
        setPageTitle(data.name);
        this.eventTrack({
          event: "activity_page",
          event_field: JSON.stringify({ activity_name: this.pageTitle }),
        });
      });
    },

    // 跳转游戏活动页面
    async onSkipDetail({ activityId, activityGameId }) {
      this.$router.push({
        name: `box.actPlaceDetail`,
        query: {
          id: activityId,
          gameId: activityGameId,
          title: this.pageTitle
        },
      });
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.error_state {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  background: #fc4b44;
  overflow: auto;
  background-size: cover;
  .pageBack {
    width: 100%;
  }
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
    .download {
      top: 0px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .pageContent {
    width: 88.9%;
    margin: 0 auto 20px;
    padding: 11.34px 10.36px 10.65px;
    background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
    border-radius: 4px;
    box-shadow: 1px 1px 3px 1px rgba(185, 31, 8, 0.64),
      1px 1px 0px 1px rgba(255, 255, 255, 0.75) inset,
      0px 0px 0.61px 0px rgba(255, 77, 77, 0.83) inset;
    .placeTitle {
      font-size: 18px;
      font-weight: 700;
      text-align: left;
      line-height: 20px;
      margin-bottom: 10px;
    }
    .empty {
      color: #fc5f5e;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      > p {
        line-height: 24px;
      }
    }
    .gameList {
      display: flex;
      flex-wrap: wrap;
    }
    .gameBox {
      width: 47%;
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 6px;
      margin-left: 9px;
      .gameImg {
        width: 45px;
        height: 45px;
        margin-right: 5px;
      }
      .gameTitle {
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #666666;
        line-height: 14px;
      }
      .gameDesc {
        font-size: 12px;
        font-weight: 500;
        text-align: left;
        color: #ff7a2a;
        line-height: 12px;
        margin-top: 9px;
      }
    }
  }
  .playPart {
    margin-top: 2px;
    // height: 140px;
    overflow-y: auto;
    .placeTitle {
      color: #fc5f5e;
    }
  }
  .morePart {
    margin-top: 10px;
    // height: 290px;
    overflow-y: auto;
    .placeTitle {
      color: #ff7a2a;
    }
  }
}
</style>
